const Enter = {
  key: "Enter",
  code: "Enter"
};
const Backspace = {
  key: "Backspace",
  code: "Backspace"
};
const ArrowLeft = {
  key: "ArrowLeft",
  code: "ArrowLeft"
};
const ArrowRight = {
  key: "ArrowRight",
  code: "ArrowRight"
};
export { ArrowLeft, ArrowRight, Backspace, Enter };
